<script>
	import Icon from "../icons/Icon.svelte";

	export let couriers = [];
	export let selectedCourierForSettlement = null;
	export let settlementDate = new Date().toISOString().slice(0, 10);
	export let settlementData = null;
	export let isLoadingSettlement = false;
	export let settlementNotes = "";
	export let isSettling = false;
	export let formatCurrency = (val) => Number(val || 0).toFixed(2).replace(".", ",");

	export let onSelectCourier = () => {};
	export let onChangeDate = () => {};
	export let onReloadSettlement = () => {};
	export let onConfirmSettlement = () => {};
</script>

<div class="settlement-panel">
	<!-- Barra de Filtros de Acerto -->
	<div class="settlement-top-bar">
		<div class="settle-filter-group">
			<label for="settleCourierSelect">Entregador Responsável:</label>
			<select id="settleCourierSelect" class="form-select" bind:value={selectedCourierForSettlement} on:change={onSelectCourier}>
				{#each couriers as c (c.id)}
					<option value={c}>{c.name} ({c.vehicle_type === 'bike' ? 'Bicicleta' : c.vehicle_type === 'carro' ? 'Carro' : 'Moto'})</option>
				{/each}
			</select>
		</div>

		<div class="settle-filter-group">
			<label for="settleDateInput">Data do Turno / Fechamento:</label>
			<input id="settleDateInput" type="date" class="form-input" bind:value={settlementDate} on:change={onChangeDate}>
		</div>

		<button type="button" class="btn-refresh" on:click={onReloadSettlement} disabled={isLoadingSettlement}>
			<Icon name="refresh" size={14} />
			<span>{isLoadingSettlement ? 'Calculando...' : 'Recalcular'}</span>
		</button>
	</div>

	{#if isLoadingSettlement}
		<div class="loading-state">
			<div class="loading-spinner"></div>
			<span>Calculando acerto e saldo de entregas...</span>
		</div>
	{:else if !selectedCourierForSettlement}
		<div class="empty-state-box">
			<div class="empty-state-icon"><Icon name="wallet" size={32} /></div>
			<h3>Selecione um entregador</h3>
			<p>Escolha um motoboy no filtro acima para apurar viagens, taxas e saldo líquido do turno.</p>
		</div>
	{:else if settlementData}
		{@const s = settlementData.summary}
		<!-- Card Principal do Balanço de Caixa & Prestação de Contas -->
		<div class="settlement-summary-card {s.netBalance > 0 ? 'courier-pays' : s.netBalance < 0 ? 'store-pays' : 'balanced'}">
			<div class="summary-card-header">
				<div class="summary-card-title-group">
					<span class="card-super">BALANÇO OPERACIONAL DO TURNO</span>
					<h3 class="card-result-title">{s.actionRequired}</h3>
					<span class="card-date-indicator">Data: {new Date(settlementDate + 'T12:00:00').toLocaleDateString('pt-BR')} • {selectedCourierForSettlement.name}</span>
				</div>

				<div class="net-balance-badge">
					<span class="net-balance-label">
						{s.netBalance > 0 ? 'Motoboy repassa ao caixa' : s.netBalance < 0 ? 'Loja paga ao motoboy' : 'Contas empatadas'}
					</span>
					<strong class="net-balance-value">R$ {formatCurrency(Math.abs(s.netBalance))}</strong>
				</div>
			</div>

			<div class="summary-breakdown-grid">
				<div class="breakdown-box">
					<span class="box-label">Entregas Concluídas</span>
					<strong class="box-val">{s.totalDeliveries} viagens</strong>
				</div>

				<div class="breakdown-box">
					<span class="box-label">Taxas Ganhas (+)</span>
					<strong class="box-val text-green">R$ {formatCurrency(s.totalFees)}</strong>
				</div>

				<div class="breakdown-box">
					<span class="box-label">Diária Fixa (+)</span>
					<strong class="box-val text-green">R$ {formatCurrency(s.dailyRate)}</strong>
				</div>

				<div class="breakdown-box highlight-box">
					<span class="box-label">Total Ganho pelo Motoboy</span>
					<strong class="box-val text-orange">R$ {formatCurrency(s.totalEarned)}</strong>
				</div>

				<div class="breakdown-box warning-box">
					<span class="box-label">Dinheiro em Espécie na Rua</span>
					<strong class="box-val text-blue">R$ {formatCurrency(s.totalCashCollected)}</strong>
				</div>
			</div>
		</div>

		<!-- Lista Detalhada de Pedidos Entregues no Turno -->
		<div class="settlement-orders-section">
			<div class="orders-section-header">
				<h4>Extrato de Pedidos Entregues</h4>
				<span class="orders-count-badge">{settlementData.orders?.length || 0} registros</span>
			</div>

			{#if !settlementData.orders || settlementData.orders.length === 0}
				<div class="empty-sub-state">
					<p>Nenhuma entrega finalizada registrada para este motoboy nesta data.</p>
				</div>
			{:else}
				<div class="table-container">
					<table class="modern-table compact">
						<thead>
							<tr>
								<th>Pedido</th>
								<th>Horário</th>
								<th>Cliente</th>
								<th>Endereço de Entrega</th>
								<th>Forma de Pagamento</th>
								<th>Total do Pedido</th>
								<th>Taxa do Motoboy</th>
							</tr>
						</thead>
						<tbody>
							{#each settlementData.orders as ord}
								<tr>
									<td><strong>#{ord.order_number || ord.id}</strong></td>
									<td>{ord.created_at ? new Date(ord.created_at).toLocaleTimeString().slice(0, 5) : '-'}</td>
									<td><span class="customer-name-text">{ord.customer_name}</span></td>
									<td><span class="addr-snippet" title={ord.delivery_address}>{ord.delivery_address || 'Entrega local'}</span></td>
									<td>
										<span class="pay-pill {ord.payment_method?.toLowerCase().includes('dinheiro') ? 'cash' : ''}">
											{ord.payment_method}
										</span>
									</td>
									<td><strong>R$ {formatCurrency(ord.total)}</strong></td>
									<td><span class="fee-text">+ R$ {formatCurrency(ord.motoboy_fee)}</span></td>
								</tr>
							{/each}
						</tbody>
					</table>
				</div>
			{/if}
		</div>

		<!-- Ações Finais de Fechamento -->
		<div class="settlement-footer-actions">
			<div class="notes-input-box">
				<label for="settleNotesInput">Observações do Acerto (Opcional):</label>
				<input
					id="settleNotesInput"
					type="text"
					placeholder="Ex: Adiantamento de combustível, desconto de quebra, ajuste de troco..."
					bind:value={settlementNotes}
					class="form-input"
				>
			</div>
			<button
				type="button"
				class="btn-confirm-settle"
				disabled={isSettling || !settlementData.orders || settlementData.orders.length === 0}
				on:click={onConfirmSettlement}
			>
				{#if isSettling}
					<div class="loading-spinner-sm"></div>
					<span>Gravando Fechamento...</span>
				{:else}
					<Icon name="check" size={15} />
					<span>Concluir e Salvar Acerto</span>
				{/if}
			</button>
		</div>
	{/if}
</div>

<style>
	.settlement-panel {
		background: #FFFFFF;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-lg, 16px);
		padding: 24px;
	}

	.settlement-top-bar {
		display: flex;
		align-items: flex-end;
		gap: 16px;
		margin-bottom: 24px;
		flex-wrap: wrap;
		background: #F8FAFC;
		padding: 16px 20px;
		border-radius: var(--radius-md, 12px);
		border: 1px solid var(--neutral-border, #E2E8F0);
	}

	.settle-filter-group {
		display: flex;
		flex-direction: column;
		gap: 6px;
		flex: 1;
		min-width: 200px;
	}

	.settle-filter-group label {
		font-size: 12px;
		font-weight: 700;
		color: var(--text-secondary, #475569);
	}

	.form-input, .form-select {
		padding: 10px 14px;
		border: 1px solid var(--neutral-border, #CBD5E1);
		border-radius: var(--radius-md, 8px);
		font-size: 13.5px;
		font-family: inherit;
		outline: none;
		background: #FFFFFF;
		color: var(--text-primary, #0F172A);
		transition: border-color var(--transition-fast, 0.15s ease), box-shadow var(--transition-fast, 0.15s ease);
	}

	.form-input:focus, .form-select:focus {
		border-color: var(--brand-primary, #FF6A00);
		box-shadow: 0 0 0 3px rgba(255, 106, 0, 0.15);
	}

	.btn-refresh {
		background: #0F172A;
		color: #FFFFFF;
		border: none;
		border-radius: var(--radius-md, 8px);
		padding: 10px 18px;
		font-size: 13px;
		font-weight: 700;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: background 0.15s ease;
		height: 38px;
	}

	.btn-refresh:hover:not(:disabled) {
		background: #1E293B;
	}

	.btn-refresh:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.settlement-summary-card {
		border-radius: var(--radius-lg, 16px);
		padding: 24px;
		margin-bottom: 24px;
		border: 2px solid transparent;
		box-shadow: var(--shadow-card, 0 1px 3px rgba(15, 23, 42, 0.06));
	}

	.settlement-summary-card.courier-pays {
		background: linear-gradient(135deg, #ECFDF5, #F0FDF4);
		border-color: #86EFAC;
	}

	.settlement-summary-card.store-pays {
		background: linear-gradient(135deg, #FFF7ED, #FFFBEB);
		border-color: #FED7AA;
	}

	.settlement-summary-card.balanced {
		background: #F8FAFC;
		border-color: #CBD5E1;
	}

	.summary-card-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		flex-wrap: wrap;
		gap: 16px;
	}

	.summary-card-title-group {
		display: flex;
		flex-direction: column;
		gap: 3px;
	}

	.card-super {
		font-size: 11px;
		font-weight: 800;
		color: var(--text-secondary, #64748B);
		letter-spacing: 0.8px;
	}

	.card-result-title {
		font-size: 21px;
		font-weight: 900;
		color: var(--text-primary, #0F172A);
		margin: 0;
		letter-spacing: -0.3px;
	}

	.card-date-indicator {
		font-size: 12.5px;
		color: var(--text-secondary, #475569);
		font-weight: 600;
	}

	.net-balance-badge {
		background: #FFFFFF;
		padding: 14px 22px;
		border-radius: var(--radius-md, 14px);
		box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
		text-align: right;
		border: 1px solid rgba(0, 0, 0, 0.06);
	}

	.net-balance-label {
		font-size: 11px;
		color: var(--text-secondary, #64748B);
		display: block;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.4px;
	}

	.net-balance-value {
		font-size: 26px;
		font-weight: 900;
		color: var(--text-primary, #0F172A);
	}

	.summary-breakdown-grid {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		gap: 12px;
	}

	.breakdown-box {
		background: #FFFFFF;
		padding: 14px 16px;
		border-radius: var(--radius-md, 10px);
		border: 1px solid var(--neutral-border, #E2E8F0);
		box-shadow: var(--shadow-sm, 0 1px 2px rgba(15, 23, 42, 0.05));
	}

	.breakdown-box.highlight-box {
		background: #FFF7ED;
		border-color: #FED7AA;
	}

	.breakdown-box.warning-box {
		background: #EFF6FF;
		border-color: #BFDBFE;
	}

	.box-label {
		font-size: 11px;
		color: var(--text-secondary, #64748B);
		display: block;
		margin-bottom: 4px;
		font-weight: 600;
	}

	.box-val {
		font-size: 16px;
		font-weight: 800;
	}

	.settlement-orders-section {
		margin-top: 26px;
	}

	.orders-section-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 14px;
	}

	.orders-section-header h4 {
		font-size: 15px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
		margin: 0;
	}

	.orders-count-badge {
		background: #F1F5F9;
		color: var(--text-secondary, #475569);
		font-size: 11px;
		font-weight: 700;
		padding: 2px 8px;
		border-radius: 999px;
	}

	.customer-name-text {
		font-weight: 600;
		color: var(--text-primary, #0F172A);
	}

	.addr-snippet {
		max-width: 240px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		display: block;
		font-size: 12px;
		color: var(--text-secondary, #475569);
	}

	.pay-pill {
		padding: 2px 8px;
		border-radius: 4px;
		font-size: 11px;
		font-weight: 600;
		background: #F1F5F9;
		color: var(--text-secondary, #475569);
	}

	.pay-pill.cash {
		background: #DCFCE7;
		color: #15803D;
		font-weight: 700;
	}

	.fee-text {
		color: var(--brand-primary, #FF6A00);
		font-weight: 800;
	}

	.settlement-footer-actions {
		display: flex;
		align-items: flex-end;
		gap: 16px;
		margin-top: 24px;
		padding-top: 20px;
		border-top: 1px solid var(--neutral-border, #E2E8F0);
	}

	.notes-input-box {
		flex: 1;
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.notes-input-box label {
		font-size: 12px;
		font-weight: 700;
		color: var(--text-secondary, #475569);
	}

	.btn-confirm-settle {
		background: var(--semantic-success, #059669);
		color: #FFFFFF;
		border: none;
		border-radius: var(--radius-md, 10px);
		padding: 12px 24px;
		font-size: 13.5px;
		font-weight: 800;
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 8px;
		transition: background 0.15s ease;
		height: 42px;
		white-space: nowrap;
		box-shadow: 0 2px 8px rgba(5, 150, 105, 0.25);
	}

	.btn-confirm-settle:hover:not(:disabled) {
		background: #047857;
	}

	.btn-confirm-settle:disabled {
		opacity: 0.5;
		cursor: not-allowed;
	}

	.table-container {
		overflow-x: auto;
		border: 1px solid var(--neutral-border, #E2E8F0);
		border-radius: var(--radius-md, 10px);
	}

	.modern-table {
		width: 100%;
		border-collapse: collapse;
		text-align: left;
		font-size: 13px;
		background: #FFFFFF;
	}

	.modern-table.compact th, .modern-table.compact td {
		padding: 10px 14px;
		font-size: 12.5px;
	}

	.modern-table th {
		padding: 12px 16px;
		background: #F8FAFC;
		color: var(--text-secondary, #475569);
		font-weight: 700;
		border-bottom: 1px solid var(--neutral-border, #E2E8F0);
		font-size: 11.5px;
		text-transform: uppercase;
		letter-spacing: 0.5px;
	}

	.modern-table td {
		padding: 14px 16px;
		border-bottom: 1px solid var(--neutral-border-subtle, #F1F5F9);
		color: var(--text-primary, #0F172A);
		vertical-align: middle;
	}

	.modern-table tbody tr:hover {
		background: #FAFAFA;
	}

	.loading-state, .empty-state-box {
		padding: 48px 24px;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	.empty-state-icon {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		background: #F1F5F9;
		color: #94A3B8;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-bottom: 4px;
	}

	.empty-state-box h3 {
		margin: 0;
		font-size: 17px;
		font-weight: 800;
		color: var(--text-primary, #0F172A);
	}

	.empty-state-box p {
		margin: 0;
		font-size: 13.5px;
		color: var(--text-secondary, #64748B);
		max-width: 380px;
	}

	.empty-sub-state {
		padding: 24px;
		text-align: center;
		color: var(--text-muted, #94A3B8);
		font-size: 13px;
	}

	.loading-spinner {
		width: 32px;
		height: 32px;
		border: 3px solid var(--neutral-border, #E2E8F0);
		border-top-color: var(--brand-primary, #FF6A00);
		border-radius: 50%;
		animation: spin 0.8s linear infinite;
	}

	.loading-spinner-sm {
		width: 14px;
		height: 14px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-top-color: #FFFFFF;
		border-radius: 50%;
		animation: spin 0.8s linear infinite;
	}

	.text-green { color: #16A34A !important; }
	.text-blue { color: #2563EB !important; }
	.text-orange { color: #EA580C !important; }

	@keyframes spin {
		to { transform: rotate(360deg); }
	}

	@media (max-width: 1024px) {
		.summary-breakdown-grid {
			grid-template-columns: repeat(2, 1fr);
		}
	}
</style>
